import { type PageTypes } from '@editor2/types/config';
import { type Page } from '@editor2/types/page';

export const getPageNumberIfExistsAndNotSpace = (page: Page) => {
	return page.page_number && page.page_number !== ' ' ? ` ${page.page_number}` : '';
};

export const getEnabledPageElementsTypes = (pageConfigTypes: PageTypes, pageType: string) => {
	const pageElementTypes = pageConfigTypes[pageType || 'normal'].elements;
	return Object.fromEntries(Object.entries(pageElementTypes).filter(([_, value]) => value.enabled));
};
